import { Button, Table } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { routesPath } from "src/app/routes";
import NotFound from "../../NotFound";

const ApprovedProperties = ({ propertyData, handlePendingPropertyAction }) => {
	return (
		<>
			{propertyData &&
				propertyData?.filter((p) => p.publish_status === "approved").length > 0 && (
					<Table>
						<thead className="thead-light">
							<tr>
								<th className="border-0">#ID</th>
								<th className="border-0">Name</th>
								<th className="border-0">District</th>
								<th className="border-0">Type</th>
								<th className="border-0 text-center">Price</th>
								<th className="border-0 text-center">
									<small>Search Score</small>
								</th>
								<th className="border-0 text-center">Approver</th>
								<th className="border-0 text-center">Action</th>
							</tr>
						</thead>
						<tbody>
							{propertyData
								?.filter((p) => p.publish_status === "approved")
								.map((property) => (
									<tr>
										<td className="border-0 fw-bold">{property.id}</td>
										<td className="border-0">
											<Link
												to={routesPath.Properties.path + "/" + property?.id}
												state={property?.id}
												className="d-flex align-items-center text-truncate"
											>
												<span className="h6">{property.name}</span>
											</Link>
										</td>
										<td className="border-0 fw-bold">
											{property.district.name}
										</td>
										<td className="border-0 fw-bold">
											{property.property_type.name}
										</td>
										<td className="border-0 text-center">
											{property.price_low && property.price_high
												? `${property.price_low} ~ ${property.price_high}`
												: property.price}
										</td>
										<td className="border-0 text-center">
											{property.search_score ?? 0}
										</td>
										<td className="border-0 text-center">---</td>
										<td className="border-0 text-center">
											<Button
												variant="light"
												className="m-1 p-2 fw-bold"
												style={{ fontSize: "13px" }}
												onClick={(e) =>
													handlePendingPropertyAction(
														"hidden",
														property.id
													)
												}
											>
												<b>Hide</b>
											</Button>
										</td>
									</tr>
								))}
						</tbody>
					</Table>
				)}
			{propertyData &&
				propertyData?.filter((p) => p.publish_status === "approved").length <= 0 && (
					<center>
						<NotFound isData={true} />
					</center>
				)}
		</>
	);
};

export default ApprovedProperties;
